// src/components/ui/calendar/week/WeekViewTimeRow/WeekViewTimeRowShadcn.jsx
import React from 'react';
import { cn } from '../../../../../utils/cn';
import { CalendarHourLabelShadcn } from '../../core';
import WeekViewTimeSlotShadcn from '../WeekViewTimeSlot/WeekViewTimeSlotShadcn';

const WeekViewTimeRowShadcn = ({
  hour,
  weekDates,
  onTimeSlotClick,
  getEventsForTimeSlot,
  getBackgroundEventsForTimeSlot,
  isAdmin = false,
  children, // For custom time slot content
  className = '',
  availabilityDates,
  viewingPartnerAvailability,
}) => {
  return (
    <div className={cn(
      "flex border-b border-slate-600/20 h-16",
      className
    )}>
      {/* Hour label */}
      <CalendarHourLabelShadcn hour={hour} />

      {/* Day columns container */}
      <div className="flex-1 grid grid-cols-7">
        {weekDates.map((date, dayIndex) => {
          const timeSlotEvents = getEventsForTimeSlot ? getEventsForTimeSlot(date, hour) : [];
          const backgroundEvents = getBackgroundEventsForTimeSlot ? getBackgroundEventsForTimeSlot(date, hour) : [];

          // FIXED: Calculate hasAvailability (same as MonthView/DayView)
          const dateStr = date.toISOString().split('T')[0];
          const hasAvailability = viewingPartnerAvailability && availabilityDates && availabilityDates.has(dateStr);

          return (
            <WeekViewTimeSlotShadcn
              key={dayIndex}
              date={date}
              hour={hour}
              dayIndex={dayIndex}
              events={timeSlotEvents}
              backgroundEvents={backgroundEvents}
              isClickable={isAdmin}
              onClick={onTimeSlotClick}
              hasAvailability={hasAvailability}  // ← Now properly calculated!
              viewingPartnerAvailability={viewingPartnerAvailability}
            >
              {/* Custom slot content or events */}
              {children ? children(date, hour, dayIndex) : null}
            </WeekViewTimeSlotShadcn>
          );
        })}
      </div>
    </div>
  );
};

export default WeekViewTimeRowShadcn;